export const fractionDigits = [
  { key: -1, caption: '$1,234' },
  { key: 1, caption: '$1,234.5' },
  { key: 2, caption: '$1,234.56' },
]
